import React from 'react';
import './About.css';

export default function About() {
  return (
    <div className="about-page page-wrapper">
      {/* Hero */}
      <div className="about-hero">
        <img
          src="https://images.unsplash.com/photo-1617627143750-d86bc21e42bb?w=1400&q=80"
          alt="Dhadee Boutique"
        />
        <div className="about-hero-overlay" />
        <div className="about-hero-content">
          <p className="section-label">Est. 2010</p>
          <h1>Our Story</h1>
          <p>Where tradition meets contemporary elegance</p>
        </div>
      </div>

      {/* Story */}
      <section className="about-story">
        <div className="story-image">
          <img src="https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?w=700&q=80" alt="Boutique story" />
        </div>
        <div className="story-text">
          <p className="section-label">Who We Are</p>
          <h2>A Legacy of Craftsmanship</h2>
          <p>
            Born in the heart of Nagercoil, Dhadee Boutique was founded with a single vision:
            to bring the finest Indian textiles and couture to the women of Tamil Nadu and beyond.
          </p>
          <p>
            For over a decade, we have curated an exquisite collection of bridal lehengas,
            Kanjivaram silks, Banarasi weaves, and contemporary fusion wear — each piece
            selected for its artistry, authenticity, and timeless appeal.
          </p>
          <p>
            Our name, Dhadee, is a term of endearment that speaks to the warmth and tradition
            we carry in every stitch. We believe that dressing for life's grandest moments
            deserves the most extraordinary garments.
          </p>
          <div className="story-stats">
            <div>
              <span className="stat-number">14+</span>
              <span className="stat-label">Years of Excellence</span>
            </div>
            <div>
              <span className="stat-number">5K+</span>
              <span className="stat-label">Happy Customers</span>
            </div>
            <div>
              <span className="stat-number">200+</span>
              <span className="stat-label">Unique Designs</span>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="values-section">
        <div className="section-header">
          <p className="section-label">What Drives Us</p>
          <h2 className="section-title">Our Values</h2>
        </div>
        <div className="values-grid">
          {[
            { icon: "✦", title: "Authenticity", desc: "Every piece is genuine, sourced from certified weavers and artisans across India." },
            { icon: "✦", title: "Craftsmanship", desc: "We honour the art of hand-weaving and embroidery passed down through generations." },
            { icon: "✦", title: "Sustainability", desc: "We champion natural fabrics and ethical production, protecting both people and planet." },
            { icon: "✦", title: "Personalization", desc: "Custom stitching and styling advice tailored to each bride and her vision." },
          ].map((v, i) => (
            <div key={i} className="value-card">
              <span className="value-icon">{v.icon}</span>
              <h3>{v.title}</h3>
              <p>{v.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Team */}
      <section className="team-section">
        <div className="section-header">
          <p className="section-label">The Faces Behind Dhadee</p>
          <h2 className="section-title">Meet Our Team</h2>
        </div>
        <div className="team-grid">
          {[
            { name: "Lakshmi Devi", role: "Founder & Creative Director", img: "https://images.unsplash.com/photo-1594938298603-c8148c4b4d8c?w=400&q=80" },
            { name: "Anitha Rajan", role: "Head Stylist", img: "https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=400&q=80" },
            { name: "Deepa Krishnan", role: "Bridal Consultant", img: "https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?w=400&q=80" },
          ].map((m, i) => (
            <div key={i} className="team-card">
              <div className="team-img">
                <img src={m.img} alt={m.name} />
              </div>
              <h4>{m.name}</h4>
              <p>{m.role}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
